import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-no-grant',
    templateUrl: './no-grant.component.html',
    styleUrls: ['./no-grant.component.scss'],
    standalone: false
})
export class NoGrantComponent implements OnInit {

  constructor() {
    // This is intentional
   }

  ngOnInit(): void {
    // This is intentional
  }

}
